var getPointerEvent = function(event) {
    return event.originalEvent.targetTouches ? event.originalEvent.targetTouches[0] : event;
};

function VerticalList(node) {
	var inner = node.substr(1) + "_inner";
	
	this.items = [];
	this.nodeid = node;
	this.inner = $("<div id='" + inner + "' style='position:absolute;left:0px;top:0px;width:100%;'></div>");
	$(node).append(this.inner);
	this.node = $(this.inner);
	
	inner = "#" + inner;
	
	this.loader = $("<div style='width:100%;height:100%;background-color:rgba(0,0,0,0.8);position:absolute;left:0px;top:0px;z-index:99999;color:#ffffff;font-size:16px;display:none;'><br><br><br><center>Ładowanie ...</center></div>");
	$(node).append(this.loader);
	
	this.scroll = new Scroller(inner,node);
}

VerticalList.prototype = {

	clear: function() {
		this.items.length = 0;
		this.node.html("");
	},
	
	add:function(item) {
		item.node = $(item.html)
		this.items.push(item);
		this.node.append(item.node);
	},
	
	bindEvents:function() {
		var self = this;
			
		this.node.find("[data-itemtap]").each(function(idx, item) {
			
			var a = $(item);
			a.attr("data-vlistno",idx);
			
			a.on(Events.pointer.down, function(e) {
				var pointer = getPointerEvent(e);
				var ia = $(this);
				var item = self.items[ia.attr("data-vlistno")];
				var action = ia.attr("data-itemtap");
				item.cachedX = pointer.pageX;
				item.cachedY = pointer.pageY;
				item.currentX = pointer.pageX;
				item.currentY = pointer.pageY;
				item.touchStarted = true;
				
				//Log.debug(item);
				
				setTimeout(function (){
					Log.debug(item);
						if ((item.cachedX === item.currentX) && !item.touchStarted && (item.cachedY === item.currentY)) {
							var fn = new Function(action);
							self.loader.show();
							setTimeout(fn, 50);							
							
						}
					},200);				
			});
			
			a.on(Events.pointer.move, function(e) {
				var pointer = getPointerEvent(e);
				var ia = $(this);
				var item = self.items[ia.attr("data-vlistno")];
				item.currentX = pointer.pageX;
				item.currentY = pointer.pageY;				
			});
			
			a.on(Events.pointer.up, function(e) {
				var ia = $(this);
				var item = self.items[ia.attr("data-vlistno")];
				item.touchStarted = false;
			});
		});
		
		this.scroll.calculateBounds();
	}

}